// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/marcokernler/Documents/denkfabrik-neueMedien/dev/web/20200121_2design-pre-site/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/marcokernler/Documents/denkfabrik-neueMedien/dev/web/20200121_2design-pre-site/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

